import 'core-js/stable'

import { rehydrateCss, renderApp } from '../init'
import routes from './routes'

rehydrateCss()
renderApp(routes)
